import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  ref:AngularFireStorageReference;
  basePath:string = 'student-photos';
  constructor(
    private afStorage:AngularFireStorage
  ) { }

  upload(path:string,file:any):AngularFireUploadTask{
    //create a reference to the storage bucket location
    this.ref = this.afStorage.ref(path);
    return this.ref.put(file)
  }

  delete(path:string):Promise<any>{
    //create a reference to the storage bucket location
    return this.afStorage.storage.refFromURL(path).delete();
  }



}
